export const policyColumns = [
  {
    accessorKey: "policy_number",
    header: "Policy Number",
    enableSorting: true,
  },
  {
    accessorKey: "named_insured",
    header: "Insured Name",
    enableSorting: true,
  },
  {
    accessorKey: "source",
    header: "Source",
    enableSorting: true,
  },
  {
    accessorKey: "sent_at",
    header: "Last Updated",
    enableSorting: true,
  },
  {
    accessorKey: "status",
    header: "Status",
    enableSorting: true,
    cell: ({ row }) => {
      const status = String(row.original.status || "Unknown");
      const normalized = status.toLowerCase().replaceAll('_', ' ');

      let colorClasses = "bg-gray-100 text-gray-800";

      if (["active", "bound"].includes(normalized)) {
        colorClasses = "bg-green-100 text-green-800";
      } else if (["pending cancellation", "pending cancelation"].includes(normalized)) {
        colorClasses = "bg-yellow-100 text-yellow-800";
      } else if (["rejected", "declined"].includes(normalized)) {
        colorClasses = "bg-red-100 text-red-800";
      } else if (["canceled", "cancelled"].includes(normalized)) {
        colorClasses = "bg-gray-100 text-gray-800";
      }

      return (
        <span
          className={`
            inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${colorClasses}
          `}
        >
          {status}
        </span>
      );
    },
  },
];
